import styled, { css } from 'styled-components';
import { DESKTOP_EXTRA_SMALL_WIDTH } from 'Styles/variables/sizes';
import { pxToRem } from 'Styles/utils/utils';

export const AteContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: ${pxToRem(10)};
  margin-bottom: ${pxToRem(10)};
`;

export const Aside = styled.aside`
  max-width: ${pxToRem(325)};
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const InfoContent = styled.div`
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  border-radius: 14px;
  padding: ${pxToRem(10)};
  background: ${({ theme: { colors } }) => colors.grey_1};
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  flex: 1;
  overflow: hidden;
  ${({ hasContent, theme: { colors } }) =>
    hasContent &&
    css`
      background: ${colors.white};
    `}
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    border-radius: 0;
    border: none;
  }
`;
